export default "__VITE_ASSET__DTZejWt8__"